module.exports = __webpack_public_path__ + "img/horizontal_7_6_9006.0cb3a117.png";